import * as React from 'react'
import { connect } from 'react-redux'

import { destinationEnum } from '../../../data/models/funnelOrder/destination'
import { driveThemes, Theme } from '../../../data/models/funnelOrder/theme'
import { AppState } from '../../../data/state'
import DriveExcludeCities from './DriveExcludeCities'
import FlyExcludeCities from './FlyExcludeCitiesButton'

interface ExcludeCitiesProps {
  theme: Theme
  destination?: destinationEnum
}

const ExcludeCities: React.FC<ExcludeCitiesProps> = ({
  theme,
  destination,
}) => {
  if (driveThemes.includes(theme)) {
    return (
      <DriveExcludeCities
        destination={destination || destinationEnum.allOfEurope}
      />
    )
  } else {
    return (
      <FlyExcludeCities
        destination={destination || destinationEnum.allOfEurope}
      />
    )
  }
}

export default connect((state: AppState) => ({
  theme: state.funnelOrder.theme,
}))(ExcludeCities)
